import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import StripeIntegration from '../../components/blocks/StripeIntegration';
import { setSupplierIntegration } from '../../store/actions/suppliers';

function StripeIntegrationContainer(props) {
  return <StripeIntegration {...props} />;
}

const mapStateToProps = (state) => {
  const { supplier } = state.role;

  return {
    publishable_key: supplier.stripe_publishable_key,
    has_secret_key: supplier.has_stripe_secret_key,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setIntegration: (publishable_key, secret_key) => dispatch(setSupplierIntegration(publishable_key, secret_key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StripeIntegrationContainer);

StripeIntegrationContainer.propTypes = {
  publishable_key: PropTypes.string,
  has_secret_key: PropTypes.bool,
  setIntegration: PropTypes.func.isRequired,
};
